<template>
  <VProgressCircular
    :model-value="percentage"
    :color="borderColor"
    size="66"
    role="progressbar"
    :aria-valuemin="0"
    :aria-valuemax="100"
    :aria-valuenow="percentage"
    :aria-label="translate('aria_label_radial_progress') + percentage + '%'"
  >
    <template v-slot:default>
      <slot />
    </template>
  </VProgressCircular>
</template>

<script>
const SCORE_MAX = 100

export default {
  props: {
    scoreVal: [Number, String],
    maxVal: Number,
    borderColor: String
  },
  data() {
    return {
      score: null,
      max: null,
      percentage: 0
    }
  },
  mounted() {
    this.score = this.maxVal ? this.scoreVal : SCORE_MAX
    this.max = this.maxVal ? this.maxVal : SCORE_MAX
    this.percentage = Math.round((this.score / this.max) * SCORE_MAX)
  }
}
</script>

<style scoped>
/*This must be the same value as ANIMATION_DURATION*/
:deep(.v-progress-circular__content) {
  background-color: rgb(var(--v-theme-white));
  color: rgb(var(--v-theme-graphit));
  width: 100%;
  height: 100%;
  border-radius: 50%;
}
</style>
